<div class="bcg p-4 ">
    <div class="row">
        <div class="col-lg-6 col-sm-6 col-md-6">
            <p class="nav_link_cat  ms-1">
                <span class="clickable" (click)="gotoDashboard()">Dashboard</span>
                <span [style.font-weight]="'bold'"> >> </span>
                <span>Wallet</span>
                <span [style.font-weight]="'bold'"> >> </span>
                <span class="clickable" [routerLink]="['/doqfy/wallet/amount-balance']">Amount Balance</span>
                <span [style.font-weight]="'bold'"> >> </span>
                <span>Expenditure</span>


            </p>
        </div>
        <div class="col-lg-3 col-sm-3 col-md-3 "></div>
        <div class="col-lg-3 col-sm-3 col-md-3 overlay text-right">
            <app-select-branch></app-select-branch>
        </div>
    </div>

    <div class="card card_outLine mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6 col-sm-6 col-md-6">
                    <h5 class="title_five">State wise expenditure</h5>
                    <p class="card-text text_p ">Expenditure of the User State wise</p>
                </div>
                <div class="col-lg-6 col-sm-6 col-md-6 text-right custom_button">
                    <p-button label="Add New Branch Wallet" icon="pi pi-plus-circle"
                        [routerLink]="['/doqfy/wallet/add-branch-wallet', walletId]"
                        styleClass="p-button-sm-outline"></p-button>
                    <p-button class="ms-1" label="Back" [routerLink]="['/doqfy/wallet/amount-balance']"
                        styleClass="p-button-sm-outline"></p-button>

                </div>
            </div>
        </div>
    </div>
    <div class="card card_outLine mt-3">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-2 col-sm-2 col-md-2">
                    <h5 class="title_five">Total Deposit : ₹ {{walletDetails?.balance}}</h5>
                </div>

                <div class="col-lg-2 col-sm-2 col-md-2">
                    <h5 class="title_five">State : {{walletDetails?.state.state_name}}</h5>
                </div>

                <div class="col-lg-2 col-sm-2 col-md-2">
                    <h5 class="title_five">Denomination : {{walletDetails?.denomination}}</h5>
                </div>

                <div class="col-lg-2 col-sm-2 col-md-2">
                    <h5 class="title_five">Stamp Type : {{walletDetails?.stamp_type}}</h5>
                </div>

                <!-- <div class="col-lg-2 col-sm-2 col-md-2 form_inputFields_1">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input class="form-control edit_input" type="text" pInputText placeholder="Search here.." />
                    </span>
                </div>
                <div class="col-lg-2 col-sm-2 col-md-2 overlay_1">
                    <p-select class="custom-dropdown text-left" placeholder="Select Branch" [options]="branches"
                        [(ngModel)]="displayBranch" optionLabel="name"></p-select>

                </div>
                <div class="col-lg-2 col-sm-2 col-md-2 overlay_1">
                    <p-select class="custom-dropdown text-left" [options]="denomination"
                        [(ngModel)]="selectedDenomination" placeholder="Select Denomination"
                        optionLabel="label"></p-select>

                </div>
                <div class="col-lg-2 col-sm-2 col-md-2 overlay">
                    <span>
                        <p-datepicker class="custom-calendar" [(ngModel)]="selectedDate" icon="bx bxs-calendar"
                            placeholder="Select Month" view="month" dateFormat="MM yy" [showIcon]="true" iconDisplay="input"
                            [readonlyInput]="false" inputId="monthpicker">
                        </p-datepicker>
                    </span>
                </div> -->


            </div>
            <div class="row m-2">
                <app-data-table
                    [columns]="columns"
                    [data]="expenditure"
                    [totalRecords]="totalRecords"
                    [rows]="1"
                    [paginator]="true"
                    [lazy]="true"
                    [analyticsTab]="'State Wise Expenditure'"
                    emptyMessage="No Records Found"
                    (pageChange)="onPageChange($event)"
                    (rowClick)="openAddBalance(addBalanceModal, $event)">
                    <ng-template appTableCell="balance" let-row>
                        ₹ {{ row.balance }}
                    </ng-template>

                    <ng-template appTableCell="action" let-row>
                        <div appRowActionStop>
                            <a class="viewmore" appIconAction (click)="openAddBalance(addBalanceModal, row)"><i
                                    class="pi pi-plus" pTooltip="Add Balance"></i></a>
                        </div>
                    </ng-template>
                </app-data-table>
            </div>


        </div>
    </div>


</div>

<ng-template #addBalanceModal let-modal>
    <div class="modal-header">
        <strong>Add Balance</strong>
        <button style="margin-left: 250px;" type="button" class="close" aria-label="Close"
            (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="container">
            <div class="d-flex justify-content-between mb-3">
                <div>
                    <span class="title_header">Balance Details</span>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="r1">Branch:<span class="r1s">{{selectedBranchWallet.branch.name}}</span></div>
                </div>
                <div class="col">
                    <div class="r1">Current Balance:<span class="r1s">{{selectedBranchWallet.balance}}</span></div>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col">
                    <form [formGroup]="addBalanceForm">
                                <div class="d-flex">
                                    <span class="r1">Enter Amount </span><span class="color_red">*</span>
                                    <input type="number" class="form-control branchAmount" [(ngModel)]="enteredBalance"
                                        placeholder="Enter Amount" pInputText (keypress)="numberOnly($event)"
                                        formControlName="amount">
                                    <span class="p-error" style="font-size: 0.5rem;" *ngIf="!isBalanceAdded">*Enter amount
                                    </span>
                                </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-lg-2 col-sm-2 col-md-2 offset-10">
                <div class="text-right custom_button">
                    <p-button label="Add" (click)="addBalance()" styleClass="p-button-sm-outline">
                    </p-button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<div class="toast_display_layer">
    <p-toast></p-toast>
</div>